module.exports = __webpack_public_path__ + "img/Price Tracking_old.a00aa044.svg";